import { render, staticRenderFns } from "./ActivityComputedFields.vue?vue&type=template&id=0297aedb"
import script from "./ActivityComputedFields.vue?vue&type=script&lang=js"
export * from "./ActivityComputedFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports